import React, { Component } from 'react';

class Ticker extends Component {


    render() {

        return (

            <div class="ticker-wrap-1">
            <div class="ticker-wrap">
            <div class="ticker">
              <div class="ticker__item">SOMETHING BIG IS COMING..</div>
              <div class="ticker__item">SOMETHING BIG IS COMING..</div>
              <div class="ticker__item">SOMETHING BIG IS COMING..</div>
              <div class="ticker__item">SOMETHING BIG IS COMING..</div>
              <div class="ticker__item">SOMETHING BIG IS COMING..</div>
              <div class="ticker__item">SOMETHING BIG IS COMING..</div>
              <div class="ticker__item">SOMETHING BIG IS COMING..</div>
              <div class="ticker__item">SOMETHING BIG IS COMING..</div>
              <div class="ticker__item">SOMETHING BIG IS COMING..</div>
              <div class="ticker__item">SOMETHING BIG IS COMING..</div>
              <div class="ticker__item">SOMETHING BIG IS COMING..</div>
              <div class="ticker__item">SOMETHING BIG IS COMING..</div>
              <div class="ticker__item">SOMETHING BIG IS COMING..</div>
              <div class="ticker__item">SOMETHING BIG IS COMING..</div>
              <div class="ticker__item">SOMETHING BIG IS COMING..</div>
              <div class="ticker__item">SOMETHING BIG IS COMING..</div>
              <div class="ticker__item">SOMETHING BIG IS COMING..</div>
              <div class="ticker__item">SOMETHING BIG IS COMING..</div>
            </div>
            </div>
            </div>)
    }
}

export default Ticker;